"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _debounce2 = _interopRequireDefault(require("lodash/debounce"));

var _throttle2 = _interopRequireDefault(require("lodash/throttle"));

var _polished = require("polished");

var _media = require("./../../../themes/settings/media");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Content = _styledComponents.default.div.withConfig({
  displayName: "ModalContent__Content",
  componentId: "nehmuu-0"
})(["display:block;flex:1 1 auto;overflow-y:auto;padding:", ";-webkit-overflow-scrolling:touch;p:not(:first-child){padding-top:", ";}&.ui-modal--scrolled{border-top:solid 1px ", ";}", " ", " @media (min-width:", ") and (min-height:601px){max-height:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return "0 ".concat(theme.spacing.xxxlarge, " 0 ").concat(theme.spacing.xxxlarge);
}, (0, _polished.rem)('28px'), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.neutral.dime;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.media.medium((0, _styledComponents.css)(["padding:", ";"], function (_ref4) {
    var theme = _ref4.theme;
    return "0 ".concat(theme.spacing.xxlarge, " ").concat(theme.spacing.large, " ").concat(theme.spacing.xxlarge);
  }));
}, function (_ref5) {
  var theme = _ref5.theme,
      hasOverflow = _ref5.hasOverflow;
  return hasOverflow && (0, _styledComponents.css)(["box-shadow:", ";padding-bottom:", ";"], theme.shadows.inner, theme.spacing.large);
}, _media.medium, (0, _polished.rem)('400px'));

var ModalContent = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ModalContent, _React$Component);

  var _super = _createSuper(ModalContent);

  function ModalContent(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ModalContent);
    _this = _super.call(this, props);
    _this.contentRef = /*#__PURE__*/_react.default.createRef();
    _this.state = {
      hasOverflow: false
    };
    _this.checkForOverflow = _this.checkForOverflow.bind((0, _assertThisInitialized2.default)(_this));
    _this.checkForScroll = _this.checkForScroll.bind((0, _assertThisInitialized2.default)(_this));
    _this.debouncedCheckOverflow = (0, _debounce2.default)(_this.checkForOverflow, 150);
    _this.throttledCheckScroll = (0, _throttle2.default)(_this.checkForScroll, 50);
    return _this;
  }

  (0, _createClass2.default)(ModalContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var content = this.contentRef.current;
      window.addEventListener('resize', this.debouncedCheckOverflow);
      content.addEventListener('scroll', this.throttledCheckScroll);
      this.checkForOverflow();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var content = this.contentRef.current;
      window.removeEventListener('resize', this.debouncedCheckOverflow);
      content.removeEventListener('scroll', this.checkForScroll);
    }
  }, {
    key: "checkForOverflow",
    value: function checkForOverflow() {
      var element = this.contentRef.current;

      if (element.offsetHeight < element.scrollHeight) {
        this.setState({
          hasOverflow: true
        });
      } else {
        this.setState({
          hasOverflow: false
        });
      }
    }
  }, {
    key: "checkForScroll",
    value: function checkForScroll() {
      var element = this.contentRef.current;

      if (element.scrollTop > 0) {
        element.classList.add('ui-modal--scrolled');
      } else {
        element.classList.remove('ui-modal--scrolled');
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(Content, {
        id: this.props.id,
        ref: this.contentRef,
        hasOverflow: this.state.hasOverflow
      }, this.props.children);
    }
  }]);
  return ModalContent;
}(_react.default.Component);

ModalContent.propTypes = {
  /** _Required_ id used for aria purposes. */
  id: _propTypes.default.string.isRequired
};
var _default = ModalContent;
exports.default = _default;
//# sourceMappingURL=ModalContent.js.map